import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { Stack } from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const DateRangeControl = ({
  label = "This Week",
  onPrev,
  onNext,
  onClear,
  onDateClick,
}: {
  label?: string;
  onDateClick?: () => void;
  onPrev?: () => void;
  onNext?: () => void;
  onClear?: () => void;
}) => {
  return (
    <Box
      sx={{
        background:
          "linear-gradient(135deg, rgba(255,255,255,0.05), rgba(255,255,255,0.02))",
        backdropFilter: "blur(12px)",
        border: "1px solid rgba(255,255,255,0.1)",
        borderRadius: "999px",
        display: "flex",
        alignItems: "center",
        px: 2,
        py: 1,
        gap: 1.5,
        color: "#fff",
        width: "fit-content",
        mx: "auto",
        boxShadow: "0 6px 24px rgba(0,0,0,0.2)",
      }}
    >
      <IconButton size="small" onClick={onPrev}>
        <ArrowBackIosNewIcon fontSize="small" sx={{ color: "white" }} />
      </IconButton>

      <Stack direction="row" alignItems="center" spacing={1}>
        <CalendarTodayIcon
          fontSize="small"
          sx={{ color: "white" }}
          onClick={onDateClick}
        />
        <Typography
          fontWeight={500}
          fontSize="0.95rem"
          sx={{ color: "white" }}
          onClick={onDateClick}
        >
          {label}
        </Typography>
        {onClear && (
          <IconButton size="small" onClick={onClear}>
            <CloseIcon fontSize="small" sx={{ color: "white" }} />
          </IconButton>
        )}
      </Stack>

      <IconButton size="small" onClick={onNext}>
        <ArrowForwardIosIcon fontSize="small" sx={{ color: "white" }} />
      </IconButton>
    </Box>
  );
};

export default DateRangeControl;
